import React from 'react';
import BillingFormConfirmationStyles from './BillingFormConfirmationStyles';

const BillingFormConfirmation = ({ email }) => {

  return (
    <BillingFormConfirmationStyles>
      <div className="confirmation-container">
        <div className="confirmation-header-container">
          <img className="confirmation-icon" src="/icons/support-check.svg" alt="green check" />
          <div className="confirmation-title">We received your support request</div>
        </div>
        <div className="confirmation-message-container">
          <div className="confirmation-message">We’ll be in touch with you as soon as possible.</div>
          <div className="confirmation-email-message">
            A receipt of this message has been sent to the provided email:
            <div className="confirmation-email">{email}</div>
          </div>
        </div>
      </div>
    </BillingFormConfirmationStyles>
  );
};

export default BillingFormConfirmation;